import { useRef, useState } from 'react'
import 'ckeditor5/ckeditor5.css';
import "./cloneApps.css"
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ApiRequest from '../../helper/ApiRequest';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ApiEndpoints } from '../../helper/ApiEndpoints';


export default function AddCloneApps() {
  const navigate = useNavigate();
  const CloneAppCreateEndpoint = ApiEndpoints.CloneApp.cloneAppCreate

  // below are initial states for all sections's data

  const [section1, setSection1] = useState({
    section_name: "section1",
    url: "",
    title: "",
    para: "",
    image: null,
  });

  const [section2, setSection2] = useState({
    section_name: "section2",
    url: "",
    title: "",
    para: "",
    box_icon1: null,
    box_title1: "",
    box_para1: "",
    box_icon2: null,
    box_title2: "",
    box_para2: "",
    box_icon3: null,
    box_title3: "",
    box_para3: "",

  });

  const [section3, setSection3] = useState({
    section_name: "section3",
    url: "",
    images: []
  });

  const [section4, setSection4] = useState({
    section_name: "section4",
    url: "",
    title: "",
    para: "",
    box_icon1: null,
    box_title1: "",
    box_para1: "",
    box_icon2: null,
    box_title2: "",
    box_para2: "",
    box_icon3: null,
    box_title3: "",
    box_para3: "",
    box_icon4: null,
    box_title4: "",
    box_para4: "",
    box_icon5: null,
    box_title5: "",
    box_para5: "",
    box_icon6: null,
    box_title6: "",
    box_para6: "",
    box_icon7: null,
    box_title7: "",
    box_para7: "",
    box_icon8: null,
    box_title8: "",
    box_para8: "",
  });

  const [section5, setSection5] = useState({
    section_name: "section5",
    url: "",
    title: "",
    para: "",
    pointers: "",
    image: null,
  });

  const [section6, setSection6] = useState({
    section_name: "section6",
    url: "",
    title: "",
    para: "",
    pointers: "",
    image: null,
  });

  const [section7, setSection7] = useState({
    section_name: "section7",
    url: "",
    data: [{ question: "", answer: "" }],
  });


  // below is handlechanges for all sections
  const handleSection1Change = (e) => {
    const { name, value, files } = e.target;

    setSection1((prev) => ({
      ...prev,
      [name]: name === "image" && files.length > 0 ? files[0] : value,
    }));
  };

  const handleSection2Change = (e) => {
    const { name, value, files } = e.target;

    setSection2((prevState) => ({
      ...prevState,
      [name]: files ? files[0] : value,
    }));
  };

  const MultiImageInputRef = useRef(null);
  const handleSection3Change = (e) => {
    const { name, value, files } = e.target;

    if (name === "url") {
      setSection3({ ...section3, url: value });
    } else if (name === "images") {
      const newImages = Array.from(files); // Convert FileList to Array
      setSection3({ ...section3, images: [...section3.images, ...newImages] });
      if (MultiImageInputRef.current) {
        MultiImageInputRef.current.value = "";
      }
    }
  };
  const handleRemoveImage = (index) => {
    const updatedImages = section3.images.filter((_, i) => i !== index);
    setSection3({ ...section3, images: updatedImages });
  };

  const handleSection4Change = (e) => {
    const { name, value, files } = e.target;

    setSection4((prevState) => ({
      ...prevState,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSection5Change = (e) => {
    const { name, type, value, files } = e.target;
    setSection5((prev) => ({
      ...prev,
      [name]: name === "image" && files.length > 0 ? files[0] : value,
    }));
  };
  const handleSection5CkChange = (event, editor) => {
    setSection5((prev) => ({
      ...prev,
      pointers: editor.getData(),
    }));
  };

  const handleSection6Change = (e) => {
    const { name, type, value, files } = e.target;
    setSection6((prev) => ({
      ...prev,
      [name]: name === "image" && files.length > 0 ? files[0] : value,
    }));
  };
  const handleSection6CkChange = (event, editor) => {
    setSection6((prev) => ({
      ...prev,
      pointers: editor.getData(),
    }));
  };

  const handleSection7Change = (e, index, field) => {
    const newData = [...section7.data];
    newData[index][field] = e.target.value;
    setSection7({ ...section7, data: newData });
  };
  const addQuestionAnswerSet = () => {
    setSection7({
      ...section7,
      data: [...section7.data, { question: "", answer: "" }],
    });
  };
  const removeQuestionAnswerSet = (index) => {
    const newData = section7.data.filter((_, i) => i !== index);
    setSection7({ ...section7, data: newData });
  };


  // below are submit functions for all sections

  const handleSection1Submit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in section1) {
      if (key === "image" && section1[key]) {
        formData.append(key, section1[key]);
      } else {
        formData.append(key, section1[key]);
      }
    }

    try {
      await ApiRequest("POST", CloneAppCreateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("First Section Created Successfully!");

      setSection1({
        section_name: "section1",
        url: "",
        title: "",
        para: "",
        image: null,
      });

    } catch (error) {
      toast.error(error.message || "Error submitting the form");
    }
  };

  const handleSection2Submit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in section2) {
      if (key.startsWith("box_icon") && section2[key]) {
        formData.append(key, section2[key]);
      } else {
        formData.append(key, section2[key]);
      }
    }

    try {
      await ApiRequest("POST", CloneAppCreateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Section 2 Created Successfully!");

      setSection2({
        section_name: "section2",
        url: "",
        title: "",
        para: "",
        box_icon1: null,
        box_title1: "",
        box_para1: "",
        box_icon2: null,
        box_title2: "",
        box_para2: "",
        box_icon3: null,
        box_title3: "",
        box_para3: "",
      });

    } catch (error) {
      toast.error(error.message || "Error submitting the form");
    }
  };

  const handleSection3Submit = async (e) => {
    e.preventDefault();

    if (section3.images.length < 7) {
      toast.error("Please upload at least 7 images.");
      return;
    }

    const formData = new FormData();
    formData.append("section_name", section3.section_name);
    formData.append("url", section3.url);
    section3.images.forEach((image, index) => {
      formData.append(`images[${index}]`, image);
    });

    try {
      await ApiRequest("POST", CloneAppCreateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Section 3 Created Successfully!");

      setSection3({
        section_name: "section3",
        url: "",
        images: []
      });

    } catch (error) {
      toast.error(error.message || "Error submitting the form");
    }
  };

  const handleSection4Submit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in section4) {
      if (key.startsWith("box_icon") && section4[key]) {
        formData.append(key, section4[key]);
      } else {
        formData.append(key, section4[key]);
      }
    }

    try {
      await ApiRequest("POST", CloneAppCreateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Section 4 Created Successfully!");

      setSection4({
        section_name: "section4",
        url: "",
        title: "",
        para: "",
        box_icon1: null,
        box_title1: "",
        box_para1: "",
        box_icon2: null,
        box_title2: "",
        box_para2: "",
        box_icon3: null,
        box_title3: "",
        box_para3: "",
        box_icon4: null,
        box_title4: "",
        box_para4: "",
        box_icon5: null,
        box_title5: "",
        box_para5: "",
        box_icon6: null,
        box_title6: "",
        box_para6: "",
        box_icon7: null,
        box_title7: "",
        box_para7: "",
        box_icon8: null,
        box_title8: "",
        box_para8: "",
      });

    } catch (error) {
      toast.error(error.message || "Error submitting the form");
    }
  };

  const handleSection5Submit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in section5) {
      if (key === "image" && section5[key]) {
        formData.append(key, section5[key]);
      } else {
        formData.append(key, section5[key]);
      }
    }

    try {
      await ApiRequest("POST", CloneAppCreateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Section 5 Created Successfully!");

      setSection5({
        section_name: "section5",
        url: "",
        title: "",
        para: "",
        pointers: "",
        image: null,
      });

    } catch (error) {
      toast.error(error.message || "Error submitting the form");
    }
  };

  const handleSection6Submit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in section6) {
      if (key === "image" && section6[key]) {
        formData.append(key, section6[key]);
      } else {
        formData.append(key, section6[key]);
      }
    }

    try {
      await ApiRequest("POST", CloneAppCreateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Section 6 Created Successfully!");
      setSection6({
        section_name: "section6",
        url: "",
        title: "",
        para: "",
        pointers: "",
        image: null,
      });
    } catch (error) {
      toast.error(error.message || "Error submitting the form");
    }
  };

  const handleSection7Submit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("section_name", section7.section_name);
    formData.append("url", section7.url);

    section7.data.forEach((qa, index) => {
      formData.append(`data[${index}][question]`, qa.question);
      formData.append(`data[${index}][answer]`, qa.answer);
    });

    try {
      await ApiRequest("POST", CloneAppCreateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Section 7 Created Successfully!");
      setSection7({
        section_name: "section7",
        url: "",
        data: [{ question: "", answer: "" }],
      });
      navigate("/admin/clone-app");
    } catch (error) {
      toast.error(error.message || "Error submitting the form");
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Add Clone App <span>(please submit sections from section 1 to section 7)</span></h5>
      </div>
      <div className="add-cloneapp-content">
        <div className="row">
          <div className="col-md-12">
            <div className="clone-section">
              <Tabs
                defaultActiveKey="section1"
                id="uncontrolled-tab-example"
                className="mb-3"
              >

                <Tab eventKey="section1" title="Section1">
                  <form onSubmit={handleSection1Submit}>
                    <h3 className='mt-4'>first section</h3>

                    <label>URL:*</label>
                    <input
                      name='url'
                      required
                      type="text"
                      className="form-control"
                      value={section1.url}
                      onChange={handleSection1Change}
                    />

                    <label>Heading:*</label>
                    <input
                      name="title"
                      required
                      type="text"
                      className="form-control"
                      value={section1.title}
                      onChange={handleSection1Change}
                    />

                    <label>Paragraph:*</label>
                    <input
                      name='para'
                      required
                      type="text"
                      className="form-control"
                      value={section1.para}
                      onChange={handleSection1Change}
                    />

                    <label>Image (size: 594X552 px):*</label>
                    <input
                      name="image"
                      onChange={handleSection1Change}
                      required
                      type="file"
                      className="form-control"
                    />
                    {section1.image ? <img
                      style={{ "width": "100px", "height": "auto", marginTop: "5px" }}
                      src={URL.createObjectURL(section1.image)} alt="thumbnail" />
                      : null
                    }

                    <button type="submit" className="default-btn">add section 1</button>
                  </form>
                </Tab>


                <Tab eventKey="section2" title="Section2">
                  <form onSubmit={handleSection2Submit}>
                    <h3>Second section</h3>

                    <label>URL:*</label>
                    <input
                      name='url'
                      required
                      type="text"
                      className="form-control"
                      value={section2.url}
                      onChange={handleSection2Change}
                    />

                    <label>Heading:*</label>
                    <input
                      name='title'
                      required
                      type="text"
                      className="form-control"
                      value={section2.title}
                      onChange={handleSection2Change}
                    />

                    <label>Paragraph:*</label>
                    <input
                      name='para'
                      required
                      type="text"
                      className="form-control"
                      value={section2.para}
                      onChange={handleSection2Change}
                    />

                    <label>Box  1 Heading:*</label>
                    <input
                      name="box_title1"
                      required
                      type="text"
                      className="form-control"
                      value={section2.box_title1}
                      onChange={handleSection2Change}
                    />

                    <label>Box 1 Paragraph:*</label>
                    <input
                      name="box_para1"
                      required
                      type="text"
                      className="form-control"
                      value={section2.box_para1}
                      onChange={handleSection2Change}
                    />

                    <label>Box 1 Image (size: 27X27 px in gradient):*</label>
                    <input
                      required
                      type="file"
                      className="form-control"
                      name='box_icon1'
                      onChange={handleSection2Change}
                    />
                    {section2.box_icon1 ? <img
                      style={{ "width": "50px", "height": "auto", marginTop: "5px" }}
                      src={URL.createObjectURL(section2.box_icon1)} alt="thumbnail" />
                      : null
                    }

                    <label>Box  2 Heading:*</label>
                    <input
                      name="box_title2"
                      required
                      type="text"
                      className="form-control"
                      value={section2.box_title2}
                      onChange={handleSection2Change}
                    />

                    <label>Box 2 Paragraph:*</label>
                    <input
                      name="box_para2"
                      required
                      type="text"
                      className="form-control"
                      value={section2.box_para2}
                      onChange={handleSection2Change}
                    />

                    <label>Box 2 Image (size: 27X27 px in gradient):*</label>
                    <input
                      required
                      type="file"
                      className="form-control"
                      name='box_icon2'
                      onChange={handleSection2Change}
                    />
                    {section2.box_icon2 ? <img
                      style={{ "width": "50px", "height": "auto", marginTop: "5px" }}
                      src={URL.createObjectURL(section2.box_icon2)} alt="thumbnail" />
                      : null
                    }

                    <label>Box  3 Heading:*</label>
                    <input
                      name="box_title3"
                      required
                      type="text"
                      className="form-control"
                      value={section2.box_title3}
                      onChange={handleSection2Change}
                    />

                    <label>Box 3 Paragraph:*</label>
                    <input
                      name="box_para3"
                      required
                      type="text"
                      className="form-control"
                      value={section2.box_para3}
                      onChange={handleSection2Change}
                    />

                    <label>Box 3 Image (size: 27X27 px in gradient):*</label>
                    <input
                      required
                      type="file"
                      className="form-control"
                      name='box_icon3'
                      onChange={handleSection2Change}
                    />
                    {section2.box_icon3 ? <img
                      style={{ "width": "50px", "height": "auto", marginTop: "5px" }}
                      src={URL.createObjectURL(section2.box_icon3)} alt="thumbnail" />
                      : null
                    }

                    <button type="submit" className="default-btn">add section 2</button>
                  </form>
                </Tab>


                <Tab eventKey="section3" title="Section3">
                  <form onSubmit={handleSection3Submit}>
                    <h3>Third section</h3>

                    <label>URL:*</label>
                    <input
                      name="url"
                      required
                      type="text"
                      className="form-control"
                      value={section3.url}
                      onChange={handleSection3Change}
                    />

                    <label>Minimum 7 Images (size: 372X719 px):*</label>
                    <input
                      name="images"
                      type="file"
                      className="form-control"
                      multiple
                      ref={MultiImageInputRef}
                      onChange={handleSection3Change}
                    />

                    {section3.images.length > 0 && (
                      <div style={{ marginTop: "10px" }}>
                        <h4>Selected Images</h4>
                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                          {section3.images.map((img, index) => (
                            <div key={index} style={{ margin: "5px", position: "relative" }}>
                              <img
                                style={{
                                  width: "100px",
                                  height: "auto",
                                  display: "inline",
                                }}
                                src={URL.createObjectURL(img)}
                                alt={`thumbnail-${index}`}
                              />
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  right: "0px",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}
                                onClick={() => handleRemoveImage(index)}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <button type="submit" className="default-btn">add section 3</button>
                  </form>
                </Tab>


                <Tab eventKey="section4" title="Section4">
                  <form onSubmit={handleSection4Submit}>
                    <h3>Fourth section</h3>

                    <label>URL:*</label>
                    <input
                      name="url"
                      required
                      type="text"
                      className="form-control"
                      value={section4.url}
                      onChange={handleSection4Change}
                    />

                    <label>Heading:*</label>
                    <input
                      name="title"
                      required
                      type="text"
                      className="form-control"
                      value={section4.title}
                      onChange={handleSection4Change}
                    />

                    <label>Paragraph:*</label>
                    <input
                      name="para"
                      required
                      type="text"
                      className="form-control"
                      value={section4.para}
                      onChange={handleSection4Change}
                    />

                    {[...Array(8)].map((_, index) => {
                      const boxIndex = index + 1;
                      return (
                        <div className="dynamic-field" key={boxIndex}>
                          <label>Box {boxIndex} Heading:*</label>
                          <input
                            name={`box_title${boxIndex}`}
                            required
                            type="text"
                            className="form-control"
                            value={section4[`box_title${boxIndex}`]}
                            onChange={handleSection4Change}
                          />

                          <label>Box {boxIndex} Paragraph:*</label>
                          <input
                            name={`box_para${boxIndex}`}
                            required
                            type="text"
                            className="form-control"
                            value={section4[`box_para${boxIndex}`]}
                            onChange={handleSection4Change}
                          />

                          <label>Box {boxIndex} Image (size: 97X97 px):*</label>
                          <input
                            name={`box_icon${boxIndex}`}
                            required
                            type="file"
                            className="form-control"
                            onChange={handleSection4Change}
                          />

                          {section4[`box_icon${boxIndex}`] && (
                            <img
                              style={{
                                width: "50px",
                                height: "auto",
                                marginTop: "5px",
                              }}
                              src={URL.createObjectURL(section4[`box_icon${boxIndex}`])}
                              alt={`Box ${boxIndex} thumbnail`}
                            />
                          )}
                        </div>
                      );
                    })}
                    <button type="submit" className="default-btn">add section 4</button>
                  </form>
                </Tab>


                <Tab eventKey="section5" title="Section5">
                  <form onSubmit={handleSection5Submit}>
                    <h3>Fifth section</h3>

                    <label>URL:*</label>
                    <input
                      name='url'
                      required
                      type="text"
                      className="form-control"
                      value={section5.url}
                      onChange={handleSection5Change}
                    />

                    <label>Heading:*</label>
                    <input
                      name='title'
                      required
                      type="text"
                      className="form-control"
                      value={section5.title}
                      onChange={handleSection5Change}
                    />

                    <label>Paragraph:*</label>
                    <input
                      required
                      name='para'
                      type="text"
                      className="form-control"
                      value={section5.para}
                      onChange={handleSection5Change}
                    />

                    <label>Pointers:*</label>
                    <CKEditor
                      className="form-control"
                      editor={ClassicEditor}
                      data={section5.pointers}
                      onChange={handleSection5CkChange}
                      config={{
                        toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList",
                          "numberedList", "blockQuote", "|", "undo", "redo",],
                      }}
                    />

                    <label>Image (size: 631X501 px):*</label>
                    <input
                      required
                      sec5Ref
                      name='image'
                      type="file"
                      className="form-control"
                      onChange={handleSection5Change}
                    />
                    {section5.image ? <img
                      style={{ "width": "100px", "height": "auto", marginTop: "5px" }}
                      src={URL.createObjectURL(section5.image)} alt="thumbnail" />
                      : null
                    }
                    <button type="submit" className="default-btn">add section 5</button>
                  </form>
                </Tab>


                <Tab eventKey="section6" title="Section6">
                  <form onSubmit={handleSection6Submit}>
                    <h3>Sixth section</h3>

                    <label>URL:*</label>
                    <input
                      name='url'
                      required
                      type="text"
                      className="form-control"
                      value={section6.url}
                      onChange={handleSection6Change}
                    />

                    <label>Heading:*</label>
                    <input
                      name='title'
                      required
                      type="text"
                      className="form-control"
                      value={section6.title}
                      onChange={handleSection6Change}
                    />

                    <label>Paragraph:*</label>
                    <input
                      required
                      name='para'
                      type="text"
                      className="form-control"
                      value={section6.para}
                      onChange={handleSection6Change}
                    />

                    <label>Pointers:*</label>
                    <CKEditor
                      className="form-control"
                      editor={ClassicEditor}
                      data={section6.pointers}
                      onChange={handleSection6CkChange}
                      config={{
                        toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList",
                          "numberedList", "blockQuote", "|", "undo", "redo",],
                      }}
                    />

                    <label>Image (size: 631X501 px):*</label>
                    <input
                      required
                      name='image'
                      type="file"
                      className="form-control"
                      onChange={handleSection6Change}
                    />
                    {section6.image ? <img
                      style={{ "width": "100px", "height": "auto", marginTop: "5px" }}
                      src={URL.createObjectURL(section6.image)} alt="thumbnail" />
                      : null
                    }
                    <button type="submit" className="default-btn">add section 6</button>
                  </form>
                </Tab>


                <Tab eventKey="section7" title="Section7">
                  <form onSubmit={handleSection7Submit}>
                    <h3>Seventh section</h3>

                    <label>URL:*</label>
                    <input
                      name='url'
                      required
                      type="text"
                      className="form-control"
                      value={section7.url}
                      onChange={(e) => setSection7({ ...section7, url: e.target.value })}
                    />


                    {section7.data.map((qa, index) => (
                      <div className="dynamic-field" key={index}>
                        <label>Question {index + 1}:*</label>
                        <input
                          required
                          name={`data[${index}][question]`}
                          type="text"
                          className="form-control"
                          value={qa.question}
                          onChange={(e) => handleSection7Change(e, index, "question")}
                        />

                        <label>Answer {index + 1}:*</label>
                        <input
                          required
                          name={`data[${index}][answer]`}
                          type="text"
                          className="form-control"
                          value={qa.answer}
                          onChange={(e) => handleSection7Change(e, index, "answer")}
                        />

                        {index > 0 && (
                          <div className="text-center">
                            <button
                              type="button"
                              className="btn btn-danger mt-2"
                              onClick={() => removeQuestionAnswerSet(index)}
                            >
                              Remove question {index + 1}
                            </button>
                          </div>
                        )}
                      </div>
                    ))}

                    {/* Add More button */}
                    <button
                      type="button"
                      className="btn btn-primary mt-4"
                      onClick={addQuestionAnswerSet}
                    >
                      Add Question
                    </button>

                    <button type="submit" className="default-btn">add section 7</button>
                  </form>
                </Tab>

              </Tabs>

            </div>
          </div>
        </div>
      </div >
    </>
  )
}
